<div class="event-tree-wrapper" *ngIf="customOptions">

    <div class="align-end">
        <button class="btn accent" (click)="addEvent()" *ngIf="!viewOnly">
            {{'forms.common.' + customOptions.eventAddLabel | translate}}
        </button>
    </div>

    <br />
    <div class="event-row" *ngFor="let event of events;let i=index">
        <div class="align-end" *ngIf="!viewOnly">
            <div class="btn primary" pTooltip="{{'forms.common.' + customOptions.eventAddItem | translate}}"
                (click)="addEventItem(i)">
                <i class="fa fa-plus"></i>
            </div>
        </div>

        <br />
        <div class="flex">
            <div class="center">
                <div class="event-name">
                    {{'forms.common.' + customOptions.eventItemPrev | translate}}
                    <br *ngIf="customOptions.eventItemPrev">
                    ({{i +1}})
                </div>
                <i *ngIf="!viewOnly" class="fa fa-trash icon delete"
                    pTooltip="{{'forms.common.Delete Day' | translate}}" (click)="deleteEvent(i)"></i>
            </div>
            <div class="event-list">
                <div class="event-item" *ngFor="let eventItem of event;let eventItemIndex=index">
                    <div>
                        <div class="title">
                            <ng-container [ngSwitch]="customOptions.eventItemForm.displayTitle.type">
                                <ng-container *ngSwitchCase="'translatable'">
                                    {{('forms.common.' + eventItem[customOptions.eventItemForm.displayTitle.key]) |
                                    translate}}
                                </ng-container>
                                <ng-container *ngSwitchCase="'date'">
                                    {{eventItem[customOptions.eventItemForm.displayTitle.key] | date :
                                    customOptions.eventItemForm.displayTitle.format}}
                                </ng-container>
                                <ng-container *ngSwitchCase="'time'">
                                    {{eventItem[customOptions.eventItemForm.displayTitle.key] | displayTime :
                                    customOptions.eventItemForm.displayTitle.format}}
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    {{eventItem[customOptions.eventItemForm.displayTitle.key]}}
                                </ng-container>
                            </ng-container>

                        </div>
                        <div class="subTitle">
                            <ng-container
                                *ngFor="let item of customOptions.eventItemForm.displaySubTitle;;let isLast=last">
                                <ng-container [ngSwitch]="item.type">
                                    <ng-container *ngSwitchCase="'translatable'">
                                        {{('forms.common.' + eventItem[item.key]) | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'date'">
                                        {{eventItem[item.key] | date : item.format}}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'time'">
                                        {{eventItem[item.key] | displayTime : item.format}}
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        {{eventItem[item.key]}}
                                    </ng-container>
                                </ng-container>
                                <span *ngIf="!isLast">-</span>
                            </ng-container>
                        </div>

                    </div>

                    <div>
                        <i class="fa fa-eye icon" pTooltip="{{'forms.common.Details' | translate}}"
                            (click)="viewEventItem(i,eventItemIndex)"></i>
                        <ng-container *ngIf="!viewOnly">
                            <i class="fa fa-edit icon" pTooltip="{{'forms.common.Edit' | translate}}"
                                (click)="editEventItem(i,eventItemIndex)"></i>
                            <i class="fa fa-trash icon" pTooltip="{{'forms.common.delete' | translate}}"
                                (click)=" deleteEventItem(i,eventItemIndex)"></i>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>